import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_USER_CARD_DATA, GET_USER_CARD_DATA_SUCCESS, GET_USER_CARD_DATA_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getUserCardData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/user-cards`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_USER_CARD_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_USER_CARD_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_USER_CARD_DATA_ERROR, payload: error });
  }
}

export function* watchGetUserCardData() {
  yield takeEvery(GET_USER_CARD_DATA, getUserCardData);
}

function* getUserCardDataSaga() {
  yield all([fork(watchGetUserCardData)]);
}

export default getUserCardDataSaga;
